var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "videoGeneration" }, [
    !_vm.clipTask.length
      ? _c("div", { staticClass: "task-no-data" }, [
          _vm._m(0),
          _c("div", [_vm._v("暂无内容")]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "videoGenerationContent" },
      [
        _c(
          "scrollPane",
          { staticStyle: { height: "100%" } },
          _vm._l(_vm.clipTask, function (item) {
            return _c("div", { key: item.id, staticClass: "p-l-20 p-r-20" }, [
              _c("div", { staticClass: "task-child-clip" }, [
                _c("div", { staticClass: "task-child-clip-l" }, [
                  _c("img", {
                    staticClass: "task-child-clip-l-icon",
                    attrs: {
                      src: require("@/icons/svg/gongchengshengcheng.svg"),
                      alt: "",
                    },
                  }),
                ]),
                _c("div", { staticClass: "task-child-clip-r" }, [
                  _c("div", { staticClass: "task-child-clip-r-title" }, [
                    _c("div", { staticClass: "task-child-clip-r-title-name" }, [
                      _vm._v(_vm._s(item.taskName)),
                    ]),
                    _c("div", [
                      item.taskStatus === 2
                        ? _c("span", { staticClass: "task-color-red" }, [
                            _vm._v("操作失败"),
                          ])
                        : item.taskStatus === 1
                        ? _c("span", { staticClass: "task-color-green" }, [
                            _vm._v("已完成"),
                          ])
                        : item.taskStatus === 0
                        ? _c("span", { staticClass: "c_FF7D00" }, [
                            _vm._v("进行中..."),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "task-child-clip-r-status" }, [
                    _c("div", [
                      _vm._v("线索数：" + _vm._s(item.totalNum) + " "),
                    ]),
                  ]),
                  _c("div", { staticClass: "task-child-clip-r-status" }, [
                    _vm._v(
                      " 新跟进人：" +
                        _vm._s(item.newFollowUserNickname) +
                        "   已成功线索数：" +
                        _vm._s(item.successNum) +
                        " "
                    ),
                    item.taskStatus
                      ? _c(
                          "div",
                          {
                            staticClass: "task-child-clip-r-status-del",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.delClip(item.taskId)
                              },
                            },
                          },
                          [_vm._v(" 删除 ")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ])
          }),
          0
        ),
      ],
      1
    ),
    _vm.clipTask.length
      ? _c(
          "div",
          { staticClass: "footer" },
          [
            _c("span", { staticClass: "footerTotal" }, [
              _vm._v("合计" + _vm._s(_vm.pageConfig.total) + "条"),
            ]),
            _c("pagination", {
              attrs: {
                total: _vm.pageConfig.total,
                current: _vm.pageConfig.current,
                size: _vm.pageConfig.size,
              },
              on: { currentChange: _vm.pageChange },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "task-no-data-icon-box" }, [
      _c("img", {
        staticClass: "task-no-data-icon",
        attrs: { src: require("@/icons/svg/t_nodata.svg"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }